import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import Moment from "moment";
import Select from "react-select";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Button.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";

// const history = useHistory();
const DentistUse = (props) => {
  // const patiname = props.PatientName;
  // const Formdidi = props.formDid;
  const [Formdid, setFormdid] = useState(
    props.formDid !== undefined ? props.formDid : 0,
  );
  const [columnID, setcolumnID] = useState(
    props.columnID !== undefined ? props.columnID : 0,
  );
  const [AutpattientID, setAutpattientID] = useState(props.AutpattientID);
  console.log("test", AutpattientID);
  // const patientId = props.patientId;
  const patientId =
    props.callingFrom == "update" ? props.patientid : props.patientId;
  const [patientName, setpatientName] = useState(props.patientName);
  console.log("paaa", patientName);
  const pname = props.PatientName;
  const [consentDatee, setConsentDate] = React.useState(
    Moment().format("YYYY-MM-DD"),
  );
  const [idd, setIdd] = useState("");
  const [patId, setPatId] = useState("");
  const [patName, setPatName] = useState(pname);
  const [periodCondition, setPeriodCondition] = useState("");
  const [tonsilsEnlarged, setTonsilsEnlarged] = useState("");
  const [grindingOfTeeth, setGrindingOfTeeth] = useState("");
  const [leftMovements, setLeftMovements] = useState("");
  const [maxOp, setMaxOp] = useState("");
  const [maxProt, setMaxProt] = useState("");
  const [rightMovements, setRightMovements] = useState("");
  const [palpitation, setPalpitation] = useState("");
  const [mandiMovement, setMandiMovement] = useState("");
  const [smoothMovement, setSmoothMovement] = useState("");
  const [luxation, setLuxation] = useState("");
  const [tenPlus, setTenPlus] = useState("");
  const [feelFatigued, setFeelFatigued] = useState("");
  const [notUsingCPAP, setNotUsingCPAP] = useState("");
  const [headaches, setHeadaches] = useState("");
  const [inapprop, setInapprop] = useState("");
  const [ahi, setAhi] = useState("");
  const [provName, setProvName] = useState("");
  const [provSig, setProvSig] = useState("");
  const [careProvDate, setCareProvDate] = React.useState("");
  const [consentSig, setConsentSig] = useState("");
  const [prName, setPrName] = useState("");

  const fields = [
    "id",
    "patientName",
    "patientId",
    "insuranceName",
    // "insurancId",
    // "address",
    // "city",
    // "state",
    // "zipCode",
    // "phone",
    // "heartProblems",
    // "heartProblemsDetails",
    // "highBloodPressure",
    // "highBloodPressureDetails",
    // "diabetes",
    // "diabetesDetail",
    // "thyroidSyndrome",
    // "thyroidSyndromeDeatils",
    // "prescribedMedicines",
    // "prescribedMedicinesDetails",
    // "attachList",
    // "alcoholConsumption",
    // "smokingLevel",
    // "sleepiness",
    // "impairedCognition",
    // "insomnia",
    // "ischemicHeartDisease",
    // "inappropriate",
    // "excessive",
    // "moodDisorders",
    // "hypertension",
    // "historyOfStroke",
    // "cpap",
    // "cpapDaysLimit",
    // "deviceCausing",
    // "deviceIrritated",
    // "intestinalissues",
    // "other",
    // "latexAllergy",
    // "previousSleepStudy",
    // "ahiScore",
    // "oralSleepAppliance",
    // "oralSleepYear",
    // "sittingAndReading",
    // "watchingTV",
    // "sittingInactivePlace",
    // "passengerCar",
    // "layingToRest",
    // "sittingAndTalking",
    // "sittingQuietly",
    // "consumed",
    // "carStationary",
    // "patientSignature",
    // "sleepinessDate",
    "periodontalCondition",
    "tonsilsEnlarged",
    "grindingOfTeeth",
    "palpitation",
    "mandibularMovement",
    "smoothMovement",
    "luxation",
    "epworthOfTenPlus",
    "feelingFatigued",
    "notUsingCPAP",
    "headaches",
    "inappropriateDaytimeNapping",
    "ahi",
    "providerCareName",
    "providerCareSignature",
    "careProviderDate",
    "orderingPhysicianName",
    "necessityPatient",
    "patDOB",
    "inactive",
    "practiceId",
    "maxOpening",
    "maxProtrusion",
    "maxLateralLeftMovements",
    "maxLateralRightMovements",
    "consentDate",
    "consentSignature",
    "printName",
    "total",
    "createdBy",
    "createdDate",
  ];
  const defValues = {
    id: 0,
    patientId: patientId,
    patientName: "",
    insuranceName: "",
    // insurancId: 0,
    // address: "",
    // city: "",
    // state: "",
    // zipCode: "",
    // phone: "",
    // heartProblems: "",
    // heartProblemsDetails: "",
    // highBloodPressure: "",
    // highBloodPressureDetails: "",
    // diabetes: "",
    // diabetesDetail: "",
    // thyroidSyndrome: "",
    // thyroidSyndromeDeatils: "",
    // prescribedMedicines: true,
    // prescribedMedicinesDetails: "",
    // attachList: "",
    // alcoholConsumption: "",
    // smokingLevel: "",
    // sleepiness: false,
    // impairedCognition: "",
    // insomnia: "",
    // ischemicHeartDisease: "",
    // inappropriate: "",
    // excessive: false,
    // moodDisorders: "",
    // hypertension: "",
    // historyOfStroke: "",
    // cpap: "",
    // cpapDaysLimit: "",
    // deviceCausing: "",
    // deviceIrritated: "",
    // intestinalissues: "",
    // other: "",
    // latexAllergy: "",
    // previousSleepStudy: "",
    // ahiScore: "",
    // oralSleepAppliance: "",
    // oralSleepYear: "",
    // sittingAndReading: "",
    // watchingTV: "",
    // sittingInactivePlace: "",
    // passengerCar: "",
    // layingToRest: "",
    // sittingAndTalking: "",
    // sittingQuietly: "",
    // consumed: "",
    // carStationary: "",
    // patientSignature: "",
    // sleepinessDate: "",
    periodontalCondition: "",
    tonsilsEnlarged: "",
    grindingOfTeeth: "",
    palpitation: "",
    mandibularMovement: "",
    smoothMovement: "",
    luxation: "",
    epworthOfTenPlus: "",
    feelingFatigued: "",
    notUsingCPAP: "",
    headaches: "",
    inappropriateDaytimeNapping: "",
    ahi: "",
    providerCareName: "",
    providerCareSignature: "",
    careProviderDate: "",
    orderingPhysicianName: "",
    necessityPatient: "",
    patDOB: "",
    inactive: true,
    practiceId: 0,
    maxOpening: 0,
    maxProtrusion: 0,
    maxLateralLeftMovements: 0,
    maxLateralRightMovements: 0,
    consentDate: "",
    consentSignature: "",
    printName: "",
    total: "",
    createdDate: "",
    createdBy: "",
  };

  const navigate = useNavigate();

  const alert = useAlert();

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);
  const [careProvDateError, setCareProvDateError] = useState(false);
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/DentistById?Id=${Formdid}&authId=${columnID}`,
        { headers },
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });

        console.log("response.dataaaaa: ", response);
        setIdd(response.id);
        setPatId(response.patientId);
        setPatName(response.patientName);
        setInapprop(response.inappropriateDaytimeNapping);
        setPeriodCondition(response.periodontalCondition);
        setTonsilsEnlarged(response.tonsilsEnlarged);
        setGrindingOfTeeth(response.grindingOfTeeth);
        setPalpitation(response.palpitation);
        setMandiMovement(response.mandibularMovement);
        setSmoothMovement(response.smoothMovement);
        setLuxation(response.luxation);
        setTenPlus(response.epworthOfTenPlus);
        setFeelFatigued(response.feelingFatigued);
        setNotUsingCPAP(response.notUsingCPAP);
        setHeadaches(response.headaches);
        setProvName(response.providerCareName);
        setProvSig(response.providerCareSignature);
        // var PattDob = Moment(response.patDOB).format('YYYY-MM-DD')
        setMaxOp(response.maxOpening);
        setMaxProt(response.maxProtrusion);
        setLeftMovements(response.maxLateralLeftMovements);
        setRightMovements(response.maxLateralRightMovements);
        setConsentSig(response.consentSignature);
        setPrName(response.printName);
        setAhi(response.ahi);
        // var PattDob2 = Moment(response.sleepinessDate).format('YYYY-MM-DD');
        // setDatee(PattDob2);
        if (response.status === 204 || !response) {
          setCareProvDate("");
        } else {
          const careProvDate = response.careProviderDate
            ? Moment(response.careProviderDate).format("YYYY-MM-DD")
            : ""; // Set to empty if careProviderDate is missing

          setCareProvDate(careProvDate);
        }

        var conscDob = Moment(response.consentDate.format("YYYY-MM-DD"));
        setConsentDate(conscDob);
      })

      .catch((error) => {
        console.error("There was an error!", error);
      });

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [Formdid, patId, columnID]);
  const onSubmit = (data) => {
    setSubmitting(true);
    const postData = data;
    console.log("postData", postData);
    postData.authId = columnID;
    if (!data.careProviderDate) {
      setCareProvDateError(true);
      setSubmitting(false);
      return;
    }
    {
      props.callingFrom == "Patient"
        ? (postData.patientName = patientName)
        : (postData.patientName = pname);
    }
    {
      props.callingFrom == "Patient"
        ? (postData.patientId = AutpattientID)
        : (postData.patientId = patientId);
    }
    {
      props.callingFrom == "Patient"
        ? (postData.id = idd)
        : (postData.id = idd);
    }
    // postData.patientName= patientName
    // postData.patientId = AutpattientID
    // postData.address = Address;
    console.log("check Data", postData);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddDentist`,
        postData,
        {
          headers,
        },
      )
      .then((response) => {
        if (response.id) {
          console.log("check Data", response);
          setSubmitting(false);
          toast.success("Record saved successfully", {
            position: "bottom-center",
            // autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            onClose: () => {
              if (props.callingFrom == "Patient") {
                props.updateHealthHistory(
                  response.id,
                  response.authId,
                  response.createdBy,
                  response.createdDate,
                );

                props.closedentist();
                console.log("checkid", response.id);
              } else if (props.callingFrom == "update") {
                // props.updateHealthHistory(response.id, response.authId, response.patientName)
                props.closevobpage();
              } else if (props.callingFrom == "dashboard") {
                props.updateHealthHistory(
                  response.id,
                  response.authId,
                  response.patientName,
                );
                // props.closevobpage()
              } else {
                props.closedentist();
              }
            },
          });
        } else {
          setSubmitting(false);
        }
      })
      .catch((error) => {
        setSubmitting(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
  };

  return (
    <Container maxWidth="lg">
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{
          p: 2,
          mb: 2,
        }}
      >
        {/* Header Section */}
        <Grid container spacing={3} mt={2}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              align="center"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              DENTAL ASSESSMENT FORM
            </Typography>
          </Grid>
        </Grid>

        {/* Occlusion Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Occlusion Assessment
            </Typography>
          </Grid>

          {/* Incisor Relationship */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Incisor relationship
            </Typography>
            <Controller
              name="incisorRelationship"
              control={control}
              render={({ field }) => (
                <Grid container spacing={1}>
                  {[
                    "Class 1",
                    "Class 2 Div I",
                    "Class 2 Div II",
                    "Class 3",
                  ].map((option) => (
                    <Grid item key={option}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {/* <input
                          type="radio"
                          value={option}
                          checked={field.value === option}
                          onClick={() => field.onChange(option)}
                          style={{ marginRight: 8 }}
                        /> */}
                        <Typography variant="body2">{option}</Typography>
                      </label>
                    </Grid>
                  ))}
                </Grid>
              )}
            />
          </Grid>

          {/* Overjet and Overbite */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Controller
                  name="overjetMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Overjet (mm)"
                      type="number"
                      size="small"
                      fullWidth
                     InputProps={{ readOnly: true }}
                      variant="standard"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name="overbiteMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Overbite (mm)"
                      type="number"
                      size="small"
                      fullWidth
                     InputProps={{ readOnly: true }}
                      variant="standard"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Periodontal and Tonsils Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          {/* Periodontal Condition */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Periodontal condition
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <input
                type="radio"
                value="Good"
                name="periodontalCondition"
                {...register("periodontalCondition")}
              />{" "}
              Good
              <input
                type="radio"
                value="Fair"
                name="periodontalCondition"
                {...register("periodontalCondition")}
              />{" "}
              Fair
              <input
                type="radio"
                value="Poor"
                name="periodontalCondition"
                {...register("periodontalCondition")}
              />{" "}
              Poor
            </div>
          </Grid>

          {/* Tonsils Enlarged */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Tonsils - enlarged/inflamed
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <input
                type="radio"
                checked={tonsilsEnlarged ? true : false}
                onClick={(e) => {
                  console.log("checked value", e);
                  setValue("tonsilsEnlarged", true);
                  setTonsilsEnlarged(true);
                }}
              />
              Yes
              <input
                type="radio"
                checked={tonsilsEnlarged ? false : true}
                onClick={(e) => {
                  setValue("tonsilsEnlarged", false);
                  setTonsilsEnlarged(false);
                }}
              />
              No
            </div>
          </Grid>

          {/* Bruxism */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Bruxism/clenching/grinding of teeth
            </Typography>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <input
                type="radio"
                checked={grindingOfTeeth ? true : false}
                onClick={(e) => {
                  console.log("checked value", e);
                  setValue("grindingOfTeeth", true);
                  setGrindingOfTeeth(true);
                }}
              />
              Yes
              <input
                type="radio"
                checked={grindingOfTeeth ? false : true}
                onClick={(e) => {
                  setValue("grindingOfTeeth", false);
                  setGrindingOfTeeth(false);
                }}
              />
              No
            </div>
          </Grid>
        </Grid>

        {/* TMJ Assessment Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              TMJ Assessment
            </Typography>
          </Grid>

          {/* Max Lateral Movements */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4}>
                <Typography variant="body2">Max lateral movements</Typography>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="maxLateralLeftMovements"
                  {...register("maxLateralLeftMovements")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      label="Left (mm)"
                      variant="outlined"
                      {...field}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        onInput: (e) => {
                          const inputValue = e.target.value.trim();
                          if (
                            inputValue === "" ||
                            /^[0-9]*$/.test(inputValue)
                          ) {
                            e.target.value =
                              inputValue !== ""
                                ? Math.max(0, parseInt(inputValue))
                                    .toString()
                                    .slice(0, 10)
                                : ""; // Allow only positive integers
                          } else {
                            e.target.value = ""; // Set value to empty if non-numeric input
                          }
                          field.onChange(e);
                        },
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="maxLateralRightMovements"
                  {...register("maxLateralRightMovements")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="outlined"
                      label="Right (mm)"
                      {...field}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        onInput: (e) => {
                          const inputValue = e.target.value.trim();
                          if (
                            inputValue === "" ||
                            /^[0-9]*$/.test(inputValue)
                          ) {
                            e.target.value =
                              inputValue !== ""
                                ? Math.max(0, parseInt(inputValue))
                                    .toString()
                                    .slice(0, 10)
                                : ""; // Allow only positive integers
                          } else {
                            e.target.value = ""; // Set value to empty if non-numeric input
                          }
                          field.onChange(e);
                        },
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Max Opening and Protrusion */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Controller
                  name="maxOpening"
                  {...register("maxOpening")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="number"
                      label="Max opening (mm)"
                      size="small"
                      variant="outlined"
                      {...field}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        onInput: (e) => {
                          const inputValue = e.target.value.trim();
                          if (
                            inputValue === "" ||
                            /^[0-9]*$/.test(inputValue)
                          ) {
                            e.target.value =
                              inputValue !== ""
                                ? Math.max(0, parseInt(inputValue))
                                    .toString()
                                    .slice(0, 10)
                                : ""; // Allow only positive integers
                          } else {
                            e.target.value = ""; // Set value to empty if non-numeric input
                          }
                          field.onChange(e);
                        },
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name="maxProtrusion"
                  {...register("maxProtrusion")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="number"
                      label="Max protrusion (mm)"
                      size="small"
                      variant="outlined"
                      {...field}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        onInput: (e) => {
                          const inputValue = e.target.value.trim();
                          if (
                            inputValue === "" ||
                            /^[0-9]*$/.test(inputValue)
                          ) {
                            e.target.value =
                              inputValue !== ""
                                ? Math.max(0, parseInt(inputValue))
                                    .toString()
                                    .slice(0, 10)
                                : ""; // Allow only positive integers
                          } else {
                            e.target.value = ""; // Set value to empty if non-numeric input
                          }
                          field.onChange(e);
                        },
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* TMJ Symptoms */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" fontWeight="medium" gutterBottom>
                  Tenderness to palpitation
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <input
                    type="radio"
                    checked={palpitation ? true : false}
                    onClick={(e) => {
                      console.log("checked value", e);
                      setValue("palpitation", true);
                      setPalpitation(true);
                    }}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    checked={palpitation ? false : true}
                    onClick={(e) => {
                      setValue("palpitation", false);
                      setPalpitation(false);
                    }}
                  />{" "}
                  No
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" fontWeight="medium" gutterBottom>
                  Pain on mandibular movement
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <input
                    type="radio"
                    checked={mandiMovement ? true : false}
                    onClick={(e) => {
                      console.log("checked value", e);
                      setValue("mandibularMovement", true);
                      setMandiMovement(true);
                    }}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    checked={mandiMovement ? false : true}
                    onClick={(e) => {
                      setValue("mandibularMovement", false);
                      setMandiMovement(false);
                    }}
                  />{" "}
                  No
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" fontWeight="medium" gutterBottom>
                  Smooth movement
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <input
                    type="radio"
                    checked={smoothMovement ? true : false}
                    onClick={(e) => {
                      console.log("checked value", e);
                      setValue("smoothMovement", true);
                      setSmoothMovement(true);
                    }}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    checked={smoothMovement ? false : true}
                    onClick={(e) => {
                      setValue("smoothMovement", false);
                      setSmoothMovement(false);
                    }}
                  />{" "}
                  No
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" fontWeight="medium" gutterBottom>
                  Locking and/or luxation
                </Typography>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <input
                    type="radio"
                    checked={luxation ? true : false}
                    onClick={(e) => {
                      console.log("checked value", e);
                      setValue("luxation", true);
                      setLuxation(true);
                    }}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    checked={luxation ? false : true}
                    onClick={(e) => {
                      setValue("luxation", false);
                      setLuxation(false);
                    }}
                  />{" "}
                  No
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Care Pathway Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              CARE PATHWAY
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, fontStyle: "italic" }}>
              If the following are reported, a Sleep Study should be completed
              to determine if the patient has OSA and the Informed consent
              should be completed.
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="epworthOfTenPlus"
                    checked={tenPlus}
                    onChange={() => {
                      setValue("epworthOfTenPlus", !tenPlus);
                      setTenPlus(!tenPlus);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    Epworth of 10+
                  </Typography>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="feelingFatigued"
                    checked={feelFatigued ? true : false}
                    onClick={() => {
                      setValue("feelingFatigued", !feelFatigued);
                      setFeelFatigued(!feelFatigued);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    Feeling fatigued
                  </Typography>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="notUsingCPAP"
                    checked={notUsingCPAP ? true : false}
                    onClick={() => {
                      setValue("notUsingCPAP", !notUsingCPAP);
                      setNotUsingCPAP(!notUsingCPAP);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    Not using CPAP
                  </Typography>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="headaches"
                    checked={headaches ? true : false}
                    onClick={() => {
                      setValue("headaches", !headaches);
                      setHeadaches(!headaches);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    Headaches
                  </Typography>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="inappropriateDaytimeNapping"
                    checked={inapprop ? true : false}
                    onClick={() => {
                      setValue("inappropriateDaytimeNapping", !inapprop);
                      setInapprop(!inapprop);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    Inappropriate daytime napping (e.g., during driving,
                    conversation, or eating)
                  </Typography>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "4px",
                  }}
                >
                  <Checkbox
                    name="ahi"
                    checked={ahi ? true : false}
                    onClick={() => {
                      setValue("ahi", !ahi);
                      setAhi(!ahi);
                    }}
                    sx={{
                      p: "4px", // Checkbox ki extra padding kam kar di
                      mt: "-1px", // Zarurat ho to thora adjust kar sakte hain
                    }}
                  />

                  <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
                    AHI of 5 or above (only if the patient has already had a
                    sleep test in the past)
                  </Typography>
                </label>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Provider Information */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Provider Information
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="providerCareName"
              {...register("providerCareName")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  label="Provider Name"
                  variant="outlined"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="providerCareSignature"
              {...register("providerCareSignature")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  label="Provider Signature"
                  variant="outlined"
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="careProviderDate"
              {...register("careProviderDate")}
              control={control}
              render={({ field }) => (
                <TextField
                  type="date"
                  size="small"
                  variant="outlined"
                  {...field}
                  fullWidth
                  label="Date"
                  value={careProvDate || ""}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setValue("careProviderDate", e.target.value);
                    setCareProvDate(e.target.value);
                    setCareProvDateError(false);
                  }}
                />
              )}
            />

            {careProvDateError && (
              <p style={{ color: "red" }}>Please Select Date</p>
            )}
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button
            onClick={handleSubmit(onSubmit)}
            variant="contained"
            disabled={submitting}
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            {submitting ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DentistUse;
